import { Box, Dialog, Paper, Typography } from '@mui/material';
import AppButton from '../../../../components/ui/AppButton';

const UpdateOwnerDialog = ({
  updateOwnerDialog,
  selectedUser,
  handleCloseUpdateOwnerDialog,
  handleSubmitUpdateOwner,
}) => {
  return (
    <Dialog open={updateOwnerDialog} disableEscapeKeyDown>
      <Paper sx={{ minWidth: '300px', backgroundColor: 'white', padding: '2rem' }}>
        <Typography sx={{ fontSize: '1.5rem', textAlign: 'center', marginBottom: '20px' }}>
          ต้องการย้ายสิทธิ์การแลกรางวัลให้กับ{' '}
          <Box component="span" sx={{ fontWeight: 'bold', color: '#FD0004' }}>
            {selectedUser?.displayName || selectedUser?.userId}
          </Box>{' '}
          หรือไม่?
        </Typography>
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '20px' }}>
          <AppButton
            variant="text"
            onClick={handleCloseUpdateOwnerDialog}
            sx={{
              width: '100px',
              height: '40px',
              color: '#333',
              backgroundColor: '#f5f5f5',
              fontSize: '1.25rem',

              '&:hover': {
                color: '#333',
                backgroundColor: '#f5f5f5',
                opacity: '0.85',
              },
            }}
          >
            ยกเลิก
          </AppButton>
          <AppButton
            variant="text"
            onClick={handleSubmitUpdateOwner}
            sx={{
              width: '100px',
              height: '40px',
              color: 'white',
              backgroundColor: '#dc2626',
              fontSize: '1.25rem',

              '&:hover': {
                color: 'white',
                backgroundColor: '#dc2626',
                opacity: '0.85',
              },
            }}
          >
            ตกลง
          </AppButton>
        </Box>
      </Paper>
    </Dialog>
  );
};

export default UpdateOwnerDialog;
